/* לחיה - theme behaviour. Vanilla JS, no dependencies. Every feature degrades to plain links / forms. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const rtl = document.documentElement.dir === 'rtl';
  const money = (cents) => { const v = cents / 100; return '₪' + (Number.isInteger(v) ? v : v.toFixed(2)); };

  /* ---------- sticky header height -> --sticky-top ---------- */
  const headerWrap = $('.header-section');
  if (headerWrap) {
    const setTop = () => document.documentElement.style.setProperty('--sticky-top', `${Math.round(headerWrap.getBoundingClientRect().height)}px`);
    setTop();
    if ('ResizeObserver' in window) new ResizeObserver(setTop).observe(headerWrap); else window.addEventListener('resize', setTop);
  }

  /* ---------- drawers (menu, search) ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$(`[data-drawer-open="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', d);
    const f = $('[data-autofocus]', panel) || $('input, a, button', panel); if (f) setTimeout(() => f.focus(), 30); // search: the field, so the keyboard opens
  };
  const closeDrawer = (d) => {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    $$(`[data-drawer-open="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  };
  $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', () => openDrawer(b.dataset.drawerOpen)));
  // delegated: the side cart's close buttons are re-rendered with its content
  document.addEventListener('click', (e) => { const c = e.target.closest('[data-drawer-close]'); const d = c && c.closest('[data-drawer]'); if (d) closeDrawer(d); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); closeMega(); } });
  // an open drawer is modal: Tab from its last control goes back to its first, Shift+Tab from the first to the last
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const d = $('.drawer.is-open'); const panel = d && $('.drawer__panel', d); if (!panel) return;
    const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter((el) => el.tabIndex >= 0 && el.getClientRects().length);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1], at = document.activeElement;
    if (!panel.contains(at)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- side cart (sections/cart-drawer.liquid): the header bag opens it, adding a product fills and opens it ----------
     Its inner part is swapped with fresh HTML from Shopify's section rendering; without JavaScript the bag is a link to /cart. */
  const CART_DRAWER = 'CartDrawer';
  const cartRoot = () => $('[data-cart-section]');
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  const swapCart = (sections) => {
    const sec = cartRoot(); if (!sec || !sections) return false;
    const html = sections[sec.dataset.cartSection];
    const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!fresh) return false;
    const hadFocus = sec.contains(document.activeElement);
    sec.replaceWith(fresh);
    if (hadFocus) { const h = $('[data-cart-heading]', fresh); if (h) h.focus({ preventScroll: true }); }
    return true;
  };
  const refreshCart = async () => {
    const sec = cartRoot(); if (!sec || !window.fetch || !document.getElementById(CART_DRAWER)) return;
    try { const r = await fetch(`${location.pathname}?sections=${encodeURIComponent(sec.dataset.cartSection)}`); if (r.ok) swapCart(await r.json()); } catch (e) { /* the drawer keeps what it shows */ }
  };
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (!document.getElementById(CART_DRAWER)) return; // no drawer on this page: the link goes to /cart
    e.preventDefault(); openDrawer(CART_DRAWER); refreshCart();
  }));
  // back/forward cache: the page comes back as it was, so the count and the drawer are read again
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted || !window.fetch) return;
    fetch('/cart.js').then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
    refreshCart();
  });

  /* ---------- mega menu: hover with intent delay, click/focus for keyboard and touch ---------- */
  const items = $$('[data-mega]'); let megaTimer;
  const closeMega = () => items.forEach((i) => { i.classList.remove('is-open'); const a = $('.main-nav__link', i); if (a) a.setAttribute('aria-expanded', 'false'); });
  items.forEach((item) => {
    const link = $('.main-nav__link', item);
    const open = () => { clearTimeout(megaTimer); closeMega(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
    item.addEventListener('mouseenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(open, 90); });
    item.addEventListener('mouseleave', () => { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 160); });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) closeMega(); });
  });

  /* ---------- carousels ---------- */
  $$('[data-carousel]').forEach((c) => {
    const track = $('[data-carousel-track]', c); if (!track) return;
    const prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
    const step = () => { const first = track.firstElementChild; return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : 300; };
    // RTL: scrollLeft is 0 at the start and negative towards the end
    const go = (dir) => track.scrollBy({ left: (rtl ? -1 : 1) * dir * step() * 2, behavior: 'smooth' });
    const vp = track.parentElement;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth; const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos < 4; if (next) next.disabled = pos > max - 4;
      // nothing to scroll (all cards fit): no arrows and no empty arrow lanes
      if (vp) vp.toggleAttribute('data-static', max <= 4);
    };
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
    // side arrows: centred on the product photos (the card text below them varies in height)
    const place = () => { const m = $('.card__media', track); if (!m || !vp) return; const v = vp.getBoundingClientRect(), r = m.getBoundingClientRect(); if (r.height) vp.style.setProperty('--arrow-top', `${Math.round(r.top - v.top + r.height / 2)}px`); };
    place();
    if ('ResizeObserver' in window) new ResizeObserver(() => { place(); update(); }).observe(track);
  });

  /* ---------- collection sort (client side, keeps server order as "featured") ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const grid = $('[data-grid]'); if (!grid) return;
    const lis = $$(':scope > li', grid);
    const by = { 'price-ascending': (a, b) => a.dataset.price - b.dataset.price, 'price-descending': (a, b) => b.dataset.price - a.dataset.price,
      'title-ascending': (a, b) => a.dataset.title.localeCompare(b.dataset.title, 'he'), manual: (a, b) => a.dataset.index - b.dataset.index }[sel.value];
    lis.sort(by).forEach((li) => grid.appendChild(li));
  }));

  /* ---------- category filters: every product of the category is on the page, so filtering happens here.
     The choice is kept in the address (?size=M&color=...) so a filtered list can be shared or reloaded. ---------- */
  const facets = $('[data-facets]');
  if (facets) {
    const form = $('[data-facets-form]', facets), grid = $('[data-grid]');
    const items = grid ? $$(':scope > li', grid) : [];
    const inputs = form ? $$('input[type="checkbox"]', form) : [];
    // price: two range handles; it filters only once a handle has moved off the category's own range
    const range = form ? $('[data-price-range]', form) : null;
    const pMin = range ? $('[data-price-min]', range) : null, pMax = range ? $('[data-price-max]', range) : null;
    const pLo = pMin ? +pMin.min : 0, pHi = pMin ? +pMin.max : 0;
    const priceSel = () => (pMin && (+pMin.value > pLo || +pMax.value < pHi) ? [+pMin.value, +pMax.value] : null);
    const drawPrice = () => {
      if (!range) return;
      const a = +pMin.value, b = +pMax.value, span = pHi - pLo || 1, fill = $('[data-price-fill]', range);
      if (fill) { fill.style.insetInlineStart = `${((a - pLo) / span) * 100}%`; fill.style.insetInlineEnd = `${((pHi - b) / span) * 100}%`; }
      const o1 = $('[data-price-out-min]', form), o2 = $('[data-price-out-max]', form); if (o1) o1.textContent = a; if (o2) o2.textContent = b;
      // when the two handles meet at the top of the range, the lower one stays on top so it can move back
      pMin.style.zIndex = a >= pHi - span * 0.05 ? '3' : '2'; pMax.style.zIndex = '2';
    };
    const resetPrice = () => { if (range) { pMin.value = pLo; pMax.value = pHi; drawPrice(); } };
    const countEl = $('[data-facets-count]'), totalEl = $('[data-facets-total]'), nEl = $('[data-facets-n]');
    const empty = $('[data-facets-empty]'), active = $('[data-active-facets]'), activeList = $('[data-active-list]');
    const toggle = $('[data-facets-open]'), panel = $('[data-facets-panel]', facets);
    const plural = (n) => (n === 1 ? 'מוצר אחד' : `${n} מוצרים`);
    const chosen = () => { const g = {}; inputs.forEach((i) => { if (i.checked) (g[i.name] = g[i.name] || []).push(i.value); }); const pr = priceSel(); if (pr) g.price = pr; return g; };
    const fits = (li, g) => Object.entries(g).every(([k, vals]) => {
      if (k === 'price') { const p = +li.dataset.price / 100; return p >= vals[0] && p <= vals[1]; }
      const have = (li.dataset[k] || '').split('|'); return vals.some((v) => have.includes(v));
    });
    const labelOf = (i) => { const t = $('.facet__label', i.closest('label')); return t ? t.textContent.trim() : i.value; };
    const xIcon = () => {
      const ns = 'http://www.w3.org/2000/svg', svg = document.createElementNS(ns, 'svg'), p = document.createElementNS(ns, 'path');
      svg.setAttribute('width', '14'); svg.setAttribute('height', '14'); svg.setAttribute('viewBox', '0 0 256 256'); svg.setAttribute('fill', 'currentColor'); svg.setAttribute('aria-hidden', 'true');
      p.setAttribute('d', 'M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z');
      svg.append(p); return svg;
    };
    // a category both pets share carries a dogs list and a cats list of categories in the sidebar: the cats list shows while
    // the page is filtered to cats only, the dogs list otherwise
    const petNavs = $$('[data-pet-nav]');
    const syncPetNav = () => {
      if (!petNavs.length) return;
      // a page without a pet filter (one product) follows the address: ?pet=cats
      const petInputs = inputs.filter((i) => i.name === 'pet'), alias = { dogs: 'כלבים', cats: 'חתולים' };
      const pets = petInputs.length ? petInputs.filter((i) => i.checked).map((i) => i.value) : new URLSearchParams(location.search).getAll('pet').map((v) => alias[v] || v);
      const cats = pets.length === 1 && pets[0] === 'חתולים';
      petNavs.forEach((n) => { n.hidden = (n.dataset.petNav === 'חתולים') !== cats; });
    };
    syncPetNav();
    const apply = (keepUrl) => {
      syncPetNav();
      const g = chosen(); let shown = 0;
      items.forEach((li) => { const ok = fits(li, g); li.hidden = !ok; if (ok) shown += 1; });
      // each option counts the products it would show together with the other groups; one that would show none is disabled
      inputs.forEach((i) => {
        const rest = { ...g }; delete rest[i.name];
        const n = items.filter((li) => fits(li, { ...rest, [i.name]: [i.value] })).length;
        const c = $('[data-count]', i.closest('label')); if (c) c.textContent = n;
        i.disabled = !n && !i.checked; i.closest('label').classList.toggle('is-empty', !n && !i.checked);
      });
      const on = inputs.filter((i) => i.checked), pr = priceSel(), nOn = on.length + (pr ? 1 : 0);
      if (countEl) { countEl.textContent = nOn ? plural(shown) : plural(items.length); countEl.dataset.of = nOn ? ` מתוך ${items.length}` : ''; }
      if (totalEl) totalEl.textContent = shown;
      if (nEl) { nEl.hidden = !nOn; nEl.textContent = nOn; }
      if (empty) empty.hidden = shown > 0;
      $$('.facets__foot [data-facets-clear]', facets).forEach((b) => { b.hidden = !nOn; });
      if (active && activeList) {
        active.hidden = !nOn; activeList.replaceChildren();
        if (pr) {
          const li = document.createElement('li'), b = document.createElement('button'), s = document.createElement('span'), txt = `₪${pr[0]} עד ₪${pr[1]}`;
          b.type = 'button'; b.className = 'active-facets__chip'; s.textContent = txt;
          b.setAttribute('aria-label', `הסרת הסינון ${txt}`); b.append(s, xIcon());
          b.addEventListener('click', () => { resetPrice(); apply(); });
          li.append(b); activeList.append(li);
        }
        on.forEach((i) => {
          const li = document.createElement('li'), b = document.createElement('button'), s = document.createElement('span');
          b.type = 'button'; b.className = 'active-facets__chip'; s.textContent = labelOf(i);
          b.setAttribute('aria-label', `הסרת הסינון ${labelOf(i)}`); b.append(s, xIcon());
          b.addEventListener('click', () => { i.checked = false; apply(); });
          li.append(b); activeList.append(li);
        });
      }
      if (!keepUrl) { const url = new URL(location.href); ['pet', 'price', 'size', 'color'].forEach((k) => url.searchParams.delete(k)); on.forEach((i) => url.searchParams.append(i.name, i.value)); if (pr) url.searchParams.set('price', `${pr[0]}-${pr[1]}`); history.replaceState({}, '', url); }
    };
    if (form && (inputs.length || range)) {
      const qs = new URLSearchParams(location.search);
      // menu links into a category both pets share open it filtered: ?pet=dogs or ?pet=cats (the facet values are Hebrew)
      const petAlias = { dogs: 'כלבים', cats: 'חתולים' };
      const wanted = (n) => qs.getAll(n).map((v) => (n === 'pet' && petAlias[v]) || v);
      inputs.forEach((i) => { if (wanted(i.name).includes(i.value)) i.checked = true; });
      const qp = (qs.get('price') || '').split('-').map(Number);
      if (range && qp.length === 2 && qp.every((n) => Number.isFinite(n))) { pMin.value = Math.min(Math.max(qp[0], pLo), pHi); pMax.value = Math.min(Math.max(qp[1], pLo), pHi); }
      drawPrice();
      if (range) {
        const slide = (e) => { if (+pMin.value > +pMax.value) { if (e.target === pMin) pMin.value = pMax.value; else pMax.value = pMin.value; } drawPrice(); apply(); };
        pMin.addEventListener('input', slide); pMax.addEventListener('input', slide);
      }
      form.addEventListener('change', (e) => { if (e.target.type !== 'range') apply(); });
      $$('[data-facets-clear]').forEach((b) => b.addEventListener('click', () => { inputs.forEach((i) => { i.checked = false; }); resetPrice(); apply(); }));
      if (inputs.some((i) => i.checked) || priceSel()) apply(true);
    }
    // below 1024px the sidebar opens as a panel from the side
    let back = null;
    const isOpen = () => facets.classList.contains('is-open');
    const open = () => {
      back = document.activeElement; facets.classList.add('is-open'); document.body.style.overflow = 'hidden';
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (panel) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); }
      const f = $('.facets__close', facets); if (f) setTimeout(() => f.focus(), 30);
    };
    const close = () => {
      if (!isOpen()) return;
      facets.classList.remove('is-open'); document.body.style.overflow = '';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); }
      if (back) back.focus();
    };
    if (toggle) toggle.addEventListener('click', open);
    $$('[data-facets-close]', facets).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    const wide = window.matchMedia('(min-width: 1024px)');
    if (wide.addEventListener) wide.addEventListener('change', (e) => { if (e.matches) close(); });
  }

  /* ---------- product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const json = $('[data-product-json]'); const product = json ? JSON.parse(json.textContent) : null;
    const slides = $('[data-gallery-slides]'), thumbs = $$('[data-gallery-thumb]'), counter = $('[data-gallery-counter]');
    const imgs = slides ? $$('img', slides) : [];
    const showSlide = (i, smooth = true) => { const img = imgs[i]; if (!img) return; slides.scrollTo({ left: img.offsetLeft - (rtl ? 0 : 0), behavior: smooth ? 'smooth' : 'auto' }); setCurrent(i); };
    // the thumbnail of the photo on show stays inside its strip (scrolls the strip only, never the page)
    const keepThumbInView = (t) => {
      const box = t && t.parentElement; if (!box) return;
      const r = t.getBoundingClientRect(), b = box.getBoundingClientRect();
      if (box.scrollHeight > box.clientHeight + 1) { if (r.top < b.top) box.scrollBy({ top: r.top - b.top - 8, behavior: 'smooth' }); else if (r.bottom > b.bottom) box.scrollBy({ top: r.bottom - b.bottom + 8, behavior: 'smooth' }); }
      else if (box.scrollWidth > box.clientWidth + 1) { if (r.left < b.left) box.scrollBy({ left: r.left - b.left - 8, behavior: 'smooth' }); else if (r.right > b.right) box.scrollBy({ left: r.right - b.right + 8, behavior: 'smooth' }); }
    };
    const setCurrent = (i) => { thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false')); keepThumbInView(thumbs[i]); if (counter) counter.textContent = `${i + 1} / ${imgs.length}`; };
    thumbs.forEach((t) => t.addEventListener('click', () => showSlide(+t.dataset.galleryThumb)));
    if (slides && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) setCurrent(imgs.indexOf(e.target)); }), { root: slides, threshold: [0.6] });
      imgs.forEach((im) => io.observe(im));
    }
    // variants
    const form = $('#ProductForm'); const idInput = $('[data-variant-id]'); const addBtn = $('[data-add-to-cart]');
    const priceEls = $$('[data-price]');
    const fieldsets = $$('[data-option-index]', pdp);
    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const photoOf = (x) => { if (x && x.featured_image) { const i = imgs.findIndex((im) => im.dataset.imageId == x.featured_image.id); if (i >= 0) showSlide(i); } };
    // the photo follows the value of the option with photo swatches (else the option just clicked), even when the full
    // combination is not sold
    const photoIdx = fieldsets.findIndex((fs) => fs.querySelector('.option__swatch'));
    // a value that is not sold together with the other choices looks crossed out; it stays clickable, and screen readers
    // hear that it is not available in this combination
    const markUnavailable = (opts) => fieldsets.forEach((fs, i) => $$('input', fs).forEach((inp) => {
      const sold = product.variants.some((x) => x.options.every((o, k) => (k === i ? o === inp.value : o === opts[k])));
      const lab = inp.nextElementSibling;
      if (lab) lab.classList.toggle('is-unavailable', !sold);
      if (sold) inp.removeAttribute('aria-label'); else inp.setAttribute('aria-label', `${inp.value}, לא זמין בשילוב הזה`);
    }));
    const update = (changed) => {
      if (!product) return;
      const opts = selected();
      markUnavailable(opts);
      fieldsets.forEach((fs, i) => { const s = $('[data-option-selected]', fs); if (s) s.textContent = opts[i] || ''; });
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) {
        const k = photoIdx >= 0 ? photoIdx : changed;
        if (typeof k === 'number' && k >= 0) photoOf(product.variants.find((x) => x.options[k] === opts[k] && x.featured_image));
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'השילוב הזה לא זמין'; } return;
      }
      if (idInput) idInput.value = v.id;
      priceEls.forEach((el) => (el.textContent = money(v.price)));
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'הוספה לסל' : 'אזל מהמלאי'; }
      photoOf(v);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    fieldsets.forEach((fs, k) => fs.addEventListener('change', () => update(k)));
    const qv = new URL(location.href).searchParams.get('variant');
    if (qv && product) { const v = product.variants.find((x) => String(x.id) === qv); if (v) { fieldsets.forEach((fs, i) => { $$('input', fs).forEach((inp) => (inp.checked = inp.value === v.options[i])); }); update(); } }
    if (product && fieldsets.length > 1) markUnavailable(selected());
    // quantity
    $$('[data-qty]').forEach((b) => b.addEventListener('click', () => { const inp = b.parentElement.querySelector('input'); inp.value = Math.max(1, Math.min(20, (+inp.value || 1) + +b.dataset.qty)); }));
    // add to cart (AJAX on Shopify, falls back to the normal form post): the side cart comes back with the answer
    // (bundled section rendering) and opens; an error shows under the button
    if (form) form.addEventListener('submit', async (e) => {
      if (!window.fetch || !window.Shopify) return; // local preview: let the form behave normally
      e.preventDefault();
      addBtn.disabled = true;
      const errEl = $('[data-add-error]'); if (errEl) errEl.hidden = true;
      const sec = document.getElementById(CART_DRAWER) ? cartRoot() : null;
      try {
        const body = new FormData(form);
        if (sec) { body.append('sections', sec.dataset.cartSection); body.append('sections_url', location.pathname); }
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || '');
        const cart = await (await fetch('/cart.js')).json();
        setCount(cart.item_count);
        const st = $('[data-cart-status]'); if (st) st.textContent = 'המוצר נוסף לסל';
        if (sec && swapCart(data.sections)) { addBtn.disabled = false; openDrawer(CART_DRAWER); return; }
        addBtn.textContent = 'נוסף לסל';
        setTimeout(() => { addBtn.textContent = 'הוספה לסל'; addBtn.disabled = false; }, 1800);
      } catch (err) {
        addBtn.disabled = false;
        if (errEl) { errEl.textContent = err.message || errEl.dataset.fallback; errEl.hidden = false; }
      }
    });
    // sticky buy bar on mobile, once the main button scrolls away
    const sticky = $('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { const show = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1; }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => addBtn.focus(), 400); });
    }
  }

  /* ---------- dialogs (size chart) ---------- */
  $$('[data-dialog-open]').forEach((b) => b.addEventListener('click', () => { const d = document.getElementById(b.dataset.dialogOpen); if (d && d.showModal) d.showModal(); }));
  $$('dialog').forEach((d) => { $$('[data-dialog-close]', d).forEach((b) => b.addEventListener('click', () => d.close())); d.addEventListener('click', (e) => { if (e.target === d) d.close(); }); });

  /* ---------- accordions: open and close with a short height ease instead of a jump ----------
     FAQ answers, the product page rows and the mobile menu groups. The answer stays in the page HTML either way; a visitor
     who asks the system for less motion keeps the instant toggle. A click during the ease turns it around from where it is. */
  const lessMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  $$('.faq details, .accordion details, .drawer__nav details').forEach((d) => {
    const summary = $(':scope > summary', d);
    if (!summary || !d.animate) return;
    let anim = null, closing = false;
    summary.addEventListener('click', (e) => {
      if (lessMotion.matches) return;
      e.preventDefault();
      const from = d.offsetHeight; // the height on screen now, also in the middle of an ease
      if (anim) { anim.cancel(); anim = null; }
      let to;
      if (!d.open || closing) { closing = false; d.open = true; to = d.offsetHeight; }
      else { closing = true; d.open = false; to = d.offsetHeight; d.open = true; }
      d.style.overflow = 'hidden';
      anim = d.animate({ height: [`${from}px`, `${to}px`] }, { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      anim.onfinish = () => { anim = null; d.style.overflow = ''; if (closing) { closing = false; d.open = false; } };
    });
  });

  /* ---------- cart page: quantity steppers and remove without a page reload ---------- */
  // A change goes to /cart/change.js by the line's key, together with a request for this section's fresh HTML
  // (Shopify's bundled section rendering), and the section is swapped in place. Without JavaScript, or if the swap
  // fails, the remove links (item.url_to_remove) and the update button of the normal form do the same job.
  if ($('[data-cart-section]')) {
    document.documentElement.classList.add('cart-js');
    const live = document.createElement('p');
    live.className = 'visually-hidden'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
    document.body.append(live);
    const clamp = (n) => Math.max(0, Math.min(99, Number.isFinite(n) ? n : 0));
    let busy = false, timer = null;
    const queue = new Map(); // one waiting change per line, applied in order once the request in flight returns
    const change = async (key, quantity) => {
      if (!key) return;
      if (busy) { queue.set(key, quantity); return; }
      const sec = $('[data-cart-section]'); if (!sec) return;
      busy = true; sec.classList.add('is-busy'); sec.setAttribute('aria-busy', 'true');
      const err = $('[data-cart-error]', sec);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: [sec.dataset.cartSection], sections_url: window.location.pathname }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) { if (err) { err.textContent = data.description || sec.dataset.errorText; err.hidden = false; } return; }
        $$('[data-cart-count]').forEach((el) => { el.textContent = data.item_count; el.hidden = data.item_count === 0; });
        const html = data.sections && data.sections[sec.dataset.cartSection];
        const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
        if (!fresh) { window.location.reload(); return; }
        // the control that had focus (a +/- or the quantity field of this line) gets it back in the new HTML
        const at = document.activeElement, atLine = at && at.closest && at.closest('[data-key]');
        const atSel = at && at.matches && (at.matches('[data-cart-step]') ? `[data-cart-step="${at.dataset.cartStep}"]` : at.matches('[data-cart-qty]') ? '[data-cart-qty]' : null);
        sec.replaceWith(fresh);
        if (quantity === 0) { const h = $('[data-cart-heading]', fresh); if (h) h.focus({ preventScroll: true }); }
        else if (atLine && atSel) { const back = $$('[data-key]', fresh).find((li) => li.dataset.key === atLine.dataset.key); const el = back && $(atSel, back); if (el) el.focus({ preventScroll: true }); }
        live.textContent = fresh.dataset.updatedText || '';
      } catch (e) {
        window.location.reload();
      } finally {
        busy = false;
        const now = $('[data-cart-section]'); if (now) { now.classList.remove('is-busy'); now.removeAttribute('aria-busy'); }
        const next = queue.entries().next();
        if (!next.done) { const [k, q] = next.value; queue.delete(k); change(k, q); }
      }
    };
    const keyOf = (el) => { const li = el.closest('[data-key]'); return li ? li.dataset.key : null; };
    document.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-cart-section] [data-cart-remove]');
      if (rm) { e.preventDefault(); clearTimeout(timer); change(keyOf(rm), 0); return; }
      const step = e.target.closest('[data-cart-section] [data-cart-step]');
      if (!step) return;
      const input = $('[data-cart-qty]', step.closest('[data-key]'));
      input.value = clamp((parseInt(input.value, 10) || 0) + Number(step.dataset.cartStep));
      clearTimeout(timer);
      timer = setTimeout(() => change(keyOf(input), Number(input.value)), 350);
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-section] [data-cart-qty]');
      if (input) { clearTimeout(timer); change(keyOf(input), clamp(parseInt(input.value, 10))); }
    });
    // Enter in a quantity field: update that line instead of posting the whole form (checkout still posts)
    document.addEventListener('submit', (e) => {
      if (!e.target.closest('[data-cart-section]') || (e.submitter && e.submitter.name === 'checkout')) return;
      e.preventDefault();
      const input = document.activeElement && document.activeElement.closest('[data-cart-qty]');
      if (input) { clearTimeout(timer); change(keyOf(input), clamp(parseInt(input.value, 10))); }
    });
  }
})();

/* ---------- order tracking page (15/10): the result shows inside the card, in 17TRACK's tracking frame (it finds the
   carrier by itself). Its script loads on the first check only, without its ads and header; if it does not load, the
   card says so and the links to 17TRACK and to Israel Post's Hebrew page (both carrying the number) remain. Without
   JavaScript the form itself opens 17TRACK in a new tab with the number filled in. ---------- */
(() => {
  const form = document.querySelector('[data-track-form]');
  if (!form) return;
  const card = form.parentElement;
  const input = form.querySelector('[data-track-input]');
  const result = card.querySelector('[data-track-result]');
  const status = card.querySelector('[data-track-status]');
  const frame = card.querySelector('[data-track-widget]');
  const link17 = card.querySelector('[data-track-17]');
  const linkPost = card.querySelector('[data-track-post]');
  let loading = null;
  const loadWidget = () => loading || (loading = new Promise((resolve, reject) => {
    if (window.YQV5) { resolve(); return; }
    const s = document.createElement('script');
    s.src = 'https://www.17track.net/externalcall.js'; s.async = true;
    s.onload = () => (window.YQV5 ? resolve() : reject(new Error('no YQV5')));
    s.onerror = () => { loading = null; reject(new Error('blocked')); };
    document.head.append(s);
  }));
  const say = (text, num) => {
    status.textContent = text + (num ? ' ' : '');
    if (num) { const b = document.createElement('bdi'); b.dir = 'ltr'; b.textContent = num; status.append(b); }
  };
  form.addEventListener('submit', (e) => {
    const num = (input.value || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    if (!num) return;
    e.preventDefault();
    input.value = num;
    link17.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(num);
    linkPost.href = 'https://doar.israelpost.co.il/deliverytracking?itemcode=' + encodeURIComponent(num);
    result.hidden = false;
    frame.hidden = false;
    frame.textContent = '';
    say(status.dataset.loadingText, num);
    loadWidget().then(() => {
      window.YQV5.trackSingle({ YQ_ContainerId: frame.id, YQ_Height: window.innerWidth < 600 ? 520 : 560, YQ_Width: Math.max(280, Math.round(frame.getBoundingClientRect().width)), YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num, YQ_RmAD: true, YQ_RmHeader: true });
      say(status.dataset.openedText, num);
    }).catch(() => { frame.hidden = true; say(status.dataset.failText); });
  });
  // a link that carries the number (?nums=, the link in the shipping email) fills the field and checks it straight away
  const fromLink = (new URLSearchParams(location.search).get('nums') || '').slice(0, 40);
  if (fromLink.replace(/[^0-9A-Za-z]/g, '')) {
    input.value = fromLink;
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  }
})();
